// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BMy2","expireSoon":"styles_expireSoon__3-JL4"};